export default __webpack_public_path__ + "static/media/home_thumb_sf2.9ae313b4.png";